// extracted by css-extract-rspack-plugin
export default {"cls1":"ZeroState-cls1__iJ","cls2":"ZeroState-cls2_d2p ZeroState-cls1__iJ"};